import { cn } from "@/lib/cn";

export interface SpinnerProps {
  tamanio?: "sm" | "md";
  etiqueta?: string;
  className?: string;
}

export function Spinner({ tamanio = "md", etiqueta = "Cargando…", className }: SpinnerProps) {
  return (
    <span role="status" aria-label={etiqueta} className={cn("inline-flex items-center", className)}>
      <span
        aria-hidden
        className={cn(
          "animate-spin rounded-full border-2 border-current border-t-transparent",
          tamanio === "sm" ? "size-4" : "size-6",
        )}
      />
    </span>
  );
}
